"use client";

import { MindstringPrototype, type Target } from "@/generated/fastapi";
import StudioFreeListArrangement from "../workflows/arrangement/StudioFreeListArrangement";

type StudioFreeListArrangementPanelProps = {
  prototype: MindstringPrototype;
  rerankTarget?: Target;
};

export default function StudioFreeListArrangementPanel({
  prototype,
  rerankTarget,
}: StudioFreeListArrangementPanelProps) {
  return (
    <StudioFreeListArrangement
      prototype={prototype}
      rerankTarget={rerankTarget}
    />
  );
}
